angular.module('impactx.userlist').controller('UserNoOrderCtrl', [
    '$scope',
    'dataGen',
    'ToastService',
    '$mdDialog',
    'TranslationService',
    UserNoOrderCtrl
]);

function UserNoOrderCtrl($scope, dataGen, ToastService, $mdDialog, TranslationService) {
    var ctrl = this;
    ctrl.saveLabel = TranslationService.get("save");
    ctrl.abortLabel = TranslationService.get("abort");
    ctrl.requiredLabel = TranslationService.get("required");
    ctrl.startDate = {label: ctrl.startDateLabel, dateValue: null};
    ctrl.endDate = {label: ctrl.endDateLabel, dateValue: null};
    ctrl.save = function () {
        var selectedIdsAsInteger = [];
        for (var i = 0; i < ctrl.usrIds.length; i++) {
            selectedIdsAsInteger.push(parseInt(ctrl.usrIds[i]));
        }
        dataGen.postAsForm({}, {usrIds : selectedIdsAsInteger, startDate: ctrl.startDate, endDate: ctrl.endDate}, "/user/setnoorder").then(function () {
            $mdDialog.hide();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        });
    };

    ctrl.cancel = function () {
        $mdDialog.cancel();
    }

}